<template>
  <div>
    <h4 class="form-title">Общая накладная</h4>
    <b-row>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="Transport_ModeCode"
          inputId="Transport_ModeCode"
          inputName="Код документа"
          :inputValidationRules="{ max: 30, required: true, regex: /^\d+$/ }"
          :required="true"
          :inputItems="nsiDocuments"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'name', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { Transport_DocumentName: 'name' }
          ]"
          query="p"
          :delay="1"
          select="code"
          :getData="loadNsiDocuments"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="Transport_DocumentName"
          inputId="Transport_DocumentName"
          inputName="Наименование документа"
          :inputItems="nsiDocuments"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'name', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { Transport_ModeCode: 'code' }
          ]"
          query="p"
          :delay="1"
          select="name"
          :getData="loadNsiDocuments"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="Transport_DocumentNumber"
          :name="'№ документа'"
          :rules="{ required: true, max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-3"
            label="№ документа"
            label-for="input-3"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!houseShipmentForm.Transport_DocumentNumber), 'empty-field': !(!!houseShipmentForm.Transport_DocumentNumber) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-3"
              :class="{ 'form-input': true, 'filled-field': (!!houseShipmentForm.Transport_DocumentNumber), 'required-field': !(!!houseShipmentForm.Transport_DocumentNumber) }"
              v-model="houseShipmentForm.Transport_DocumentNumber"
              placeholder="№ документа"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-datepicker
          ref="Transport_DocumentDate"
          inputId="Transport_DocumentDate"
          inputName="Дата документа"
          :disabled="notForEdit"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
    </b-row>
    <h4 class="form-title">Индивидуальная накладная</h4>
    <b-row>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="HouseWaybill_ModeCode"
          inputId="HouseWaybill_ModeCode"
          inputName="Код документа"
          :inputValidationRules="{ max: 30, required: true }"
          :required="true"
          :inputItems="nsiDocuments"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'name', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { HouseWaybill_DocumentName: 'name' }
          ]"
          query="p"
          :delay="1"
          select="code"
          :getData="loadNsiDocuments"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="HouseWaybill_DocumentName"
          inputId="HouseWaybill_DocumentName"
          inputName="Наименование документа"
          :inputItems="nsiDocuments"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'name', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { HouseWaybill_ModeCode: 'code' }
          ]"
          query="p"
          :delay="1"
          select="name"
          :getData="loadNsiDocuments"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="HouseWaybill_DocumentNumber"
          :name="'№ документа'"
          :rules="{ required: true, max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-7"
            label="№ документа"
            label-for="input-7"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!houseShipmentForm.HouseWaybill_DocumentNumber), 'empty-field': !(!!houseShipmentForm.HouseWaybill_DocumentNumber) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-7"
              :class="{ 'form-input': true, 'filled-field': (!!houseShipmentForm.HouseWaybill_DocumentNumber), 'required-field': !(!!houseShipmentForm.HouseWaybill_DocumentNumber) }"
              v-model="houseShipmentForm.HouseWaybill_DocumentNumber"
              placeholder="№ документа"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-datepicker
          ref="HouseWaybill_DocumentDate"
          inputId="HouseWaybill_DocumentDate"
          inputName="Дата документа"
          :disabled="notForEdit"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
    </b-row>
    <h4 class="form-title">Отправитель</h4>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="consignorName"
          name="Наименование отправителя"
          :rules="{ required: true, max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="Наименование отправителя"
            label-for="input-15"
            :label-class="(!!houseShipmentForm.Consignor_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="{ 'form-input': true, 'filled-field': (!!houseShipmentForm.Consignor_Name), 'required-field': !(!!houseShipmentForm.Consignor_Name) }"
              v-model="houseShipmentForm.Consignor_Name"
              placeholder="Наименование отправителя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="сonsignorPhone"
          name="Телефон отправителя"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-10"
            label="Телефон"
            label-for="input-10"
            :label-class="(!!houseShipmentForm.Consignor_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-10"
              :class="(!!houseShipmentForm.Consignor_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignor_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="consignorEmail"
          name="Электронная почта отправителя"
          :rules="{ max: 35, regex: /^[^@]+@\w+(\.\w+)+\w$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-11"
            label="Электронная почта"
            label-for="input-11"
            :label-class="(!!houseShipmentForm.Consignor_Email) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-11"
              :class="(!!houseShipmentForm.Consignor_Email) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignor_Email"
              placeholder="Электронная почта"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorINN"
            :name="'ИНН отправителя'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-12"
              label="ИНН"
              label-for="input-12"
              :label-class="(!!houseShipmentForm.Consignor_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-12"
                :class="(!!houseShipmentForm.Consignor_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="houseShipmentForm.Consignor_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorKPP"
            :name="'КПП отправителя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-13"
              label="КПП"
              label-for="input-13"
              :label-class="(!!houseShipmentForm.Consignor_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-13"
                :class="(!!houseShipmentForm.Consignor_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="houseShipmentForm.Consignor_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorOGRN"
            :name="'ОГРН отправителя'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-14"
              label="ОГРН"
              label-for="input-14"
              :label-class="(!!houseShipmentForm.Consignor_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-14"
                :class="(!!houseShipmentForm.Consignor_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="houseShipmentForm.Consignor_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="6" cols="12">
        <custom-input
          ref="Consignor_AddressInd"
          inputId="Consignor_AddressInd"
          inputName="Код вида адреса"
          :inputItems="AddressKindOptions"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
             { key: 'value', label: 'Код' },
             { key: 'text', label: 'Тип' }
           ]"
          :loadOnFocus="true"
          select="value"
          :getData="() => { return promise.resolve() }"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="6" cols="12">
        <custom-input
          ref="Consignor_CountryCode"
          inputId="Consignor_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2, required: Boolean(houseShipmentForm.Consignor_KPP && houseShipmentForm.Consignor_INN && houseShipmentForm.Consignor_OGRN) }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="4" md="4" sm="12" cols="12">
        <custom-input
          ref="Consignor_CountryName"
          inputId="Consignor_CountryName"
          inputName="Наименование страны отправителя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorPostalCode"
            :name="'Индекс отправителя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-18"
              label="Почтовый индекс"
              label-for="input-18"
              :label-class="(!!houseShipmentForm.Consignor_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-18"
                :class="(!!houseShipmentForm.Consignor_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="houseShipmentForm.Consignor_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignor_Region"
            inputId="Consignor_Region"
            inputName="Область (регион, штат, провинция и т.п.) отправителя"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consignorCity"
            :name="'Населенный пункт отправителя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-20"
              label="Населенный пункт"
              label-for="input-20"
              :label-class="(!!houseShipmentForm.Consignor_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-20"
                :class="(!!houseShipmentForm.Consignor_City) ? 'form-input filled-field' : 'form-input'"
                v-model="houseShipmentForm.Consignor_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignor_StreetHouse"
            inputId="Consignor_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-title">Получатель</h4>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="consigneeName"
          :name="'Наименование получателя'"
          :rules="{ max: 150, required: true }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-22"
            label="Наименование получателя"
            label-for="input-22"
            :label-class="(!!houseShipmentForm.Consignee_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-22"
              :class="{ 'form-input': true, 'filled-field': (!!houseShipmentForm.Consignee_Name), 'required-field': !(!!houseShipmentForm.Consignee_Name) }"
              v-model="houseShipmentForm.Consignee_Name"
              placeholder="Наименование получателя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="consigneePhone"
          name="Телефон получателя"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-23"
            label="Телефон"
            label-for="input-23"
            :label-class="(!!houseShipmentForm.Consignee_Phone) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-23"
              :class="(!!houseShipmentForm.Consignee_Phone) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignee_Phone"
              placeholder="Телефон"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="consigneeEmail"
          name="Адрес электронной почты получателя"
          :rules="{ max: 35, regex: /^[^@]+@\w+(\.\w+)+\w$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-24"
            label="Электронная почта"
            label-for="input-24"
            :label-class="(!!houseShipmentForm.Consignee_Email) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-24"
              :class="(!!houseShipmentForm.Consignee_Email) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignee_Email"
              placeholder="Электронная почта"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="6" cols="12">
        <custom-input
          ref="Consignee_AddressInd"
          inputId="Consignee_AddressInd"
          inputName="Код вида адреса"
          :inputItems="AddressKindOptions"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
             { key: 'value', label: 'Код' },
             { key: 'text', label: 'Тип' }
           ]"
          :loadOnFocus="true"
          select="value"
          :getData="() => { return promise.resolve() }"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="6" cols="12">
        <custom-input
          ref="Consignee_CountryCode"
          inputId="Consignee_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="4" lg="4" md="4" sm="12" cols="12">
        <custom-input
          ref="Consignee_CountryName"
          inputId="Consignee_CountryName"
          inputName="Наименование страны получателя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consigneePostalCode"
            :name="'Индекс получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="Почтовый индекс"
              label-for="input-28"
              :label-class="(!!houseShipmentForm.Consignee_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!houseShipmentForm.Consignee_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="houseShipmentForm.Consignee_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignee_Region"
            inputId="Consignee_Region"
            inputName="Область (регион, штат, провинция и т.п.) получателя"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="consigneeCity"
            :name="'Населенный пункт получателя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-29"
              label="Населенный пункт"
              label-for="input-29"
              :label-class="(!!houseShipmentForm.Consignee_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-29"
                :class="(!!houseShipmentForm.Consignee_City) ? 'form-input filled-field' : 'form-input'"
                v-model="houseShipmentForm.Consignee_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignee_StreetHouse"
            inputId="Consignee_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-subtitle">Документ, удостоверяющий личность</h4>
    <b-row>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <custom-input
          ref="Consignee_IdentityCountryCode"
          inputId="Consignee_IdentityCountryCode"
          inputName="Код страны регистрации"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_IdentityCountryCode: 'abc2' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <custom-input
          ref="Consignee_IdentityCardCode"
          inputId="Consignee_IdentityCardCode"
          inputName="Код вида документа"
          :inputItems="nsiIdentityDocuments"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'abbr', label: 'Аббревиатура' },
            { key: 'description', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { Consignee_IdentityCardName: 'abbr' },
            { Consignee_FullIdentityCardName: 'description' }
          ]"
          :getData="loadNsiIdentityDocuments"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="code"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <custom-input
          ref="Consignee_IdentityCardName"
          inputId="Consignee_IdentityCardName"
          inputName="Краткое наименование"
          :inputItems="nsiIdentityDocuments"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'abbr', label: 'Аббревиатура' },
            { key: 'description', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { Consignee_IdentityCardCode: 'code' },
            { Consignee_FullIdentityCardName: 'description' }
          ]"
          :getData="loadNsiIdentityDocuments"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abbr"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <custom-input
          ref="Consignee_FullIdentityCardName"
          inputId="Consignee_FullIdentityCardName"
          inputName="Полное наименование"
          :inputItems="nsiIdentityDocuments"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'abbr', label: 'Аббревиатура' },
            { key: 'description', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { Consignee_IdentityCardCode: 'code' },
            { Consignee_IdentityCardName: 'abbr' }
          ]"
          :getData="loadNsiIdentityDocuments"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="description"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="consigneeIdentityCardSeries"
          name="Серия документа"
          v-slot="validationContext">
          <b-form-group
            id="input-group-35"
            label="Серия документа"
            label-for="input-35"
            :label-class="(!!houseShipmentForm.Consignee_IdentityCardSeries) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-35"
              :class="(!!houseShipmentForm.Consignee_IdentityCardSeries) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignee_IdentityCardSeries"
              placeholder="Серия документа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="consigneeIdentityCardNumber"
          name="Номер документа"
          :rules="{ regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Номер документа"
            label-for="input-36"
            :label-class="(!!houseShipmentForm.Consignee_IdentityCardNumber) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!houseShipmentForm.Consignee_IdentityCardNumber) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignee_IdentityCardNumber"
              placeholder="Номер документа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <custom-datepicker
          ref="Consignee_IdentityCardDate"
          inputId="Consignee_IdentityCardDate"
          inputName="Дата выдачи"
          :disabled="notForEdit"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <custom-datepicker
          ref="Consignee_DocValidityDate"
          inputId="Consignee_DocValidityDate"
          inputName="Дата окончания"
          :disabled="notForEdit"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="consigneeIssuerCode"
          name="Код подразделения"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-39"
            label="Код подразделения"
            label-for="input-39"
            :label-class="(!!houseShipmentForm.Consignee_IssuerCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-39"
              :class="(!!houseShipmentForm.Consignee_IssuerCode) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignee_IssuerCode"
              placeholder="Код подразделения"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <validation-provider
          ref="Consignee_OrganizationName"
          name="Наименование организации, выдавшей документ"
          :rules="{ max: 50 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-40"
            label="Организация, выдавшая документ"
            label-for="input-40"
            :label-class="(!!houseShipmentForm.Consignee_OrganizationName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-40"
              :class="(!!houseShipmentForm.Consignee_OrganizationName) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignee_OrganizationName"
              placeholder="Организация, выдавшая документ"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Consignee_INN"
          name="ИНН"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-41"
            label="ИНН"
            label-for="input-41"
            :label-class="(!!houseShipmentForm.Consignee_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-41"
              :class="(!!houseShipmentForm.Consignee_INN) ? 'form-input filled-field' : 'form-input'"
              v-model="houseShipmentForm.Consignee_INN"
              placeholder="ИНН"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <h4 class="form-title">Интернет-магазин</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="TradeCountry"
          inputId="TradeCountry"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="URLShop"
          inputId="URLShop"
          inputName="Адрес сайта интернет-магазина"
          type="simple"
          :disabled="notForEdit"
          :edited="true"
          :required="false"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input> 
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CustomInput from '../../CustomInput'
  import CustomDatepicker from '../../CustomDatepicker'
  import moment from 'moment'
  export default {
    name: "HouseShipmentPage",
    props: ['getValidationState', 'houseShipment', 'notForEdit', 'targetInput'],
    components: {
      CustomInput,
      CustomDatepicker
    },
    data () {
      return {
        promise: window.Promise,
        houseShipmentForm: {
          did: null,
          DOC_ID: null,
          Transport_ModeCode: null, // Общая накладная:Вид документа
          Transport_DocumentName: null, // Общая накладная:Наименование документа
          Transport_DocumentNumber: null, // Общая накладная:Номер документа
          Transport_DocumentDate: null, // Общая накладная:Дата документа
          HouseWaybill_ModeCode: null, // Индивидуальная накладная:Вид документа
          HouseWaybill_DocumentName: null, // Индивидуальная накладная:Наименование документа
          HouseWaybill_DocumentNumber: null, // Индивидуальная накладная:Номер документа
          HouseWaybill_DocumentDate: null, // Индивидуальная накладная:Дата документа
          Consignor_Name: null, // Отправитель: наименование
          Consignor_Phone: null, // Отправитель: телефон
          Consignor_Email: null, // Отправитель:  Адрес электронной почты
          Consignor_OGRN: null, // Отправитель: ОГРН (для РФ), БИН (для Казахстана)
          Consignor_INN: null, // Отправитель:ИНН (в соответствии с национальной системой кодирования)
          Consignor_KPP: null, // Отправитель: КПП
          Consignor_AddressInd: '1', // Отправитель: Кодовое обозначение вида адреса: "1" - адрес регистрации; "2" - фактический адрес; "3" - почтовый адрес
          Consignor_CountryCode: null, // Отправитель: буквенный код страны
          Consignor_CountryName: null, // Отправитель: наименование страны
          Consignor_PostalCode: null, // Отправитель: почтовый индекс
          Consignor_Region: null, // Отправитель: область (регион, штат, провинция и т.п.)
          Consignor_City: null, // Отправитель: населенный пункт
          Consignor_StreetHouse: null, // Отправитель: улица, номер дома, номер офиса
          Consignor_AddressText: null, // Отправитель: Адрес в свободной форме
          Consignee_Name: null, // Получатель: наименование
          Consignee_Phone: null, // Получатель: телефон
          Consignee_Email: null, // Получатель: Адрес электронной почты
          Consignee_AddressInd: '1', // Получатель: Кодовое обозначение вида адреса: "1" - адрес регистрации; "2" - фактический адрес; "3" - почтовый адрес
          Consignee_CountryCode: null, // Получатель: буквенный код страны
          Consignee_CountryName: null, // Получатель: наименование страны
          Consignee_PostalCode: null, // Получатель: почтовый индекс
          Consignee_Region: null, // Получатель: область (регион, штат, провинция и т.п.)
          Consignee_City: null, // Получатель: населенный пункт
          Consignee_StreetHouse: null, // Получатель: улица, номер дома, номер офиса
          Consignee_AddressText: null, // Получатель: Адрес в свободной форме
          Consignee_PersonId: null, // Уникальный идентификатор физического лица
          Consignee_IdentityCountryCode: null, // Код страны регистрации
          Consignee_IdentityCardCode: null, // Код вида документа, удостоверяющего личность
          Consignee_IdentityCardName: null, // Краткое наименование документа удостоверяющего личность
          Consignee_IdentityCardSeries: null, // Серия документа, удостоверяющего личность
          Consignee_IdentityCardNumber: null, // Номер документа, удостоверяющего личность
          Consignee_IdentityCardDate: null, // Дата выдачи документа, удостоверяющего личность
          Consignee_DocValidityDate: null, // Дата окончания срока, в течение которого документ имеет силу
          Consignee_FullIdentityCardName: null, // Полное наименование документа, удостоверяющего личность
          Consignee_IssuerCode: null, // Код подразделения органа, выдавшего документ, удостоверяющий личность
          Consignee_OrganizationName: null, // Наименование организации, выдавшей документ
          Consignee_INN: null, // Получатель: ИНН
          TradeCountry: null, // Страна интернет-магазина. Буквенный код по классификатору стран мира
          URLShop: null, // Адрес сайта интернет-магазина
          TotalWaybillGrossWeightQuantity: null, // Общий вес брутто (кг) по индивидуальной накладной
          TotalWaybillAmount: null, // Общая стоимость товаров по индивидуальной накладной в валюте
          TotalWaybillCurrencyCode: null, // Цифровой код валюты
          TotalWaybillCurrencyCodeABR: null, // Буквенный код валюты
          TotalWaybillCustomsCost: null, // Общая таможенная стоимость товаров по индивидуальной накладной
          TotalWaybillCustomsCurrencyCode: null, // Цифровой код валюты
          TotalWaybillCustomsCurrencyCodeABR: null, // Буквенный код валюты
        },
        AddressKindOptions: [
          { value: '1', text: 'Адрес регистрации' },
          { value: '2', text: 'Фактический адрес' },
          { value: '3', text: 'Почтовый адрес' }
        ],
      }
    },
    watch: {
      houseShipment (val) {
        if (val) {
          this.houseShipmentForm = Object.assign(this.houseShipmentForm, val.data)
          this.houseShipmentForm.did = val.did
          for (let key in this.houseShipmentForm) {
            if ((key === 'Transport_ModeCode') ||
                (key === 'Transport_DocumentName') ||
                (key === 'Transport_DocumentDate') ||
                (key === 'HouseWaybill_ModeCode') ||
                (key === 'HouseWaybill_DocumentName') ||
                (key === 'HouseWaybill_DocumentDate') ||
                (key === 'Consignor_CountryCode') ||
                (key === 'Consignor_CountryName') ||
                (key === 'Consignee_CountryCode') ||
                (key === 'Consignee_CountryName') ||
                (key === 'Consignee_IdentityCountryCode') ||
                (key === 'Consignee_IdentityCardDate') ||
                (key === 'Consignee_DocValidityDate') ||
                (key === 'Consignor_Region') ||
                (key === 'Consignee_Region') ||
                (key === 'Consignor_StreetHouse') ||
                (key === 'Consignee_StreetHouse') ||
                (key === 'URLShop') ||
                (key === 'Consignor_AddressInd') ||
                (key === 'Consignee_AddressInd') ||
                (key === 'Consignee_IdentityCardCode') ||
                (key === 'Consignee_IdentityCardName') ||
                (key === 'Consignee_FullIdentityCardName') ||
                (key === 'TradeCountry')) {
                this.$refs[key].model = this.houseShipmentForm[key]
            }
          }
        }
      },
      'houseShipmentForm.HouseWaybill_DocumentNumber'(newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'RegNum': newVal }) },
      'houseShipmentForm.HouseWaybill_DocumentDate' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'RegDate': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignor_Name' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_Name': newVal }) },
      'houseShipmentForm.Consignor_INN' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_INN': newVal }) },
      'houseShipmentForm.Consignor_KPP' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_KPP': newVal }) },
      'houseShipmentForm.Consignor_OGRN' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_OGRN': newVal }) },
      'houseShipmentForm.Consignor_CountryCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_CountryCode': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignor_CountryName' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_CountryName': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignor_PostalCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_PostalCode': newVal }) },
      'houseShipmentForm.Consignor_Region' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_Region': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignor_City' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_City': newVal }) },
      'houseShipmentForm.Consignor_StreetHouse' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignor_StreetHouse': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignee_Name' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_Name': newVal }) },
      'houseShipmentForm.Consignee_INN' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_INN': newVal }) },
      'houseShipmentForm.Consignee_CountryCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_CountryCode': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignee_CountryName' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_CountryName': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignee_PostalCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_PostalCode': newVal }) },
      'houseShipmentForm.Consignee_Region' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_Region': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignee_City' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_City': newVal }) },
      'houseShipmentForm.Consignee_StreetHouse' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_StreetHouse': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignee_IdentityCardCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_IdentityCardCode': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignee_IdentityCardName'(newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateWbFields', { 'Consignee_IdentityCardName': newVal, 'isCustom': true }) },
      'houseShipmentForm.Consignee_IdentityCardSeries'(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('updateWbFields', { 'Consignee_IdentityCardSeries': newVal })
          this.$emit('updatePassFields', { 'RegSeries': newVal })
        }
      },
      'houseShipmentForm.Consignee_IdentityCardNumber'(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('updateWbFields', { 'Consignee_IdentityCardNumber': newVal })
          this.$emit('updatePassFields', { 'RegNum': newVal })
        }
      },
      'houseShipmentForm.Consignee_IdentityCardDate'(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('updateWbFields', { 'Consignee_IdentityCardDate': newVal, 'isCustom': true })
          this.$emit('updatePassFields', { 'RegDate': newVal, 'isCustom': true })
        }
      },
      'houseShipmentForm.Consignee_OrganizationName'(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('updateWbFields', { 'Consignee_IdentityCardOrgName': newVal })
          this.$emit('updatePassFields', { 'Org_Name': newVal })
        }
      },
    },
    computed: {
      ...mapState(
        {
          nsiCountries: state => state.commissionShipment.nsiCountries,
          nsiDocuments: state => state.commissionShipment.nsiDocuments,
          nsiIdentityDocuments: state => state.houseShipment.nsiIdentityDocuments,
        }
      )
    },
    mounted () {
    },
    methods: {
      updateIdbData () {
        this.$emit('updateHouseShipment')
      },
      moment: function (date) {
        moment.locale('ru')
        return moment(date)
      },
      setModel (event) {
        if (('index' in event) && ('parent' in event) && (event.index !== null) && (event.parent !== null)) {
          const name = event.fieldName.split('-')[0]
          this.houseShipmentForm[event.parent][event.index][name] = event.item
        } else {
            this.houseShipmentForm[event.fieldName] = event.item
        }
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      setRelated (event) {
        event.relatedFields.map((field) => {
          const key = Object.keys(field)[0]
          this.houseShipmentForm[key] = event.item[field[key]]
          if (/^\d{4}-\d{2}-\d{2}$/.test(event.item[field[key]])) {
            let date = event.item[field[key]].split('-')
            date = date[2] + '.' + date[1] + '.' + date[0]
            this.$refs[key].model = date
          } else {
            this.$refs[key].model = event.item[field[key]]
          }
          return field
        })
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      resetFormData () {
        const props = Object.getOwnPropertyNames(this.houseShipmentForm)
        for (let i = 0; i < props.length; i++) {
          this.houseShipmentForm[props[i]] = null
          if (this.$refs[props[i]]) {
            this.$refs[props[i]].model = null
          }
        }
      },
      ...mapActions({
        loadNsiCountries: 'commissionShipment/loadNsiCountries',
        loadNsiDocuments: 'commissionShipment/loadNsiDocuments',
        loadNsiIdentityDocuments: 'houseShipment/loadNsiIdentityDocuments',
      }),
    }
  }
</script>

<style lang="scss" scoped>
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  #FrDescription, #Reload {
    border-radius: 0 !important;
  }
  #DocumentKind {
    border-radius: 0 !important;
  }
  .form-title-forwarder {
    color: #38455d;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 5px;
  }
</style>
